import { Statistic } from 'antd'
import CopyButton from 'components/atoms/CopyButton'
import CustomButton from 'components/atoms/custom-button'
import dayjs from 'dayjs'
import useAccountInformation from 'hooks/useAccountInformation'
import { useState } from 'react'
import { onCurrency } from 'utils'
import { xenditBankSelector } from 'utils/constantValueSelector'

const XenditResult = ({ resultData, handleClickPay }) => {
  const { updateAccountInformation, isAccountInformationLoading } = useAccountInformation('/')
  const { Countdown } = Statistic
  const [isLoading, setIsloading] = useState(false)
  const deadline = dayjs(
    resultData?.expired_at || resultData?.transaction?.payment_details?.virtual_account?.expired_at
  ).valueOf()
  const selectedBank = xenditBankSelector(
    resultData?.transaction?.payment_details?.virtual_account?.bank_code
  )
  const expiredDate =
    resultData?.expired_at || resultData?.transaction?.payment_details?.virtual_account?.expired_at
  const handleClickBack = () => {
    updateAccountInformation()
    setIsloading(true)
  }
  return (
    <div className="w-full">
      {/* content */}
      <div className="flex gap-3 mb-6">
        <h1 className="text-2xl font-medium text-primary">{'Bayar'}</h1>
      </div>
      <div className="p-6 border border-lighter border-solid rounded-lg mb-6 text-center space-y-2">
        <div
          onClick={
            window.REACT_APP_XENDIT_ENV === 'staging' || window.REACT_APP_XENDIT_ENV === undefined
              ? handleClickPay
              : null
          }>
          <p className="font-medium text-primary">Selesaikan Pembayaran Pada</p>
          <p className="text-xl font-medium">
            <Countdown className="countdown-payment" value={deadline} />
          </p>
        </div>
        <div>
          <p className="text-sm text-secondary">Batas Pembayaran</p>
          <p className="font-medium text-primary">
            {dayjs(expiredDate).format('dddd, D MMMM YYYY, HH:mm')}
          </p>
        </div>
      </div>
      <div className="p-6 border border-lighter border-solid rounded-lg grid grid-cols-1 gap-y-6 mb-6">
        <p className="text-sm text-secondary">Ref. ID: {resultData?.transaction?.reference_id}</p>
        <div className="flex items-center gap-4">
          <img
            src={selectedBank?.image}
            alt="selected-bank"
            className="w-[56px] h-[24px] shrink-0 grow-0 object-contain"
          />
          <p className="font-medium text-primary text-sm">{selectedBank?.label}</p>
        </div>
        <div className="grid grid-cols-1 gap-6">
          <div>
            <p className="font-secondary mb-2">Total to be Paid</p>
            <div className="flex gap-4 items-center">
              <p className="font-medium text-primary text-2xl">
                {onCurrency(resultData?.transaction?.total_amount) || '-'}
              </p>
              <CopyButton value={resultData?.transaction?.total_amount} />
            </div>
          </div>
          <div>
            <p className="font-secondary mb-2">Account Number</p>
            <div className="flex gap-4 items-center">
              <p className="font-medium text-primary text-2xl">
                {resultData?.transaction?.payment_details?.virtual_account?.va_number}
              </p>
              <CopyButton
                value={resultData?.transaction?.payment_details?.virtual_account?.va_number}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="w-full">
        <CustomButton
          isLoading={isLoading || isAccountInformationLoading}
          type="plain"
          onClick={handleClickBack}
          className="w-full"
          disabled={isLoading}>
          Kembali ke halaman utama
        </CustomButton>
      </div>
    </div>
  )
}

export default XenditResult
